const IntegrationNames = {
  HUBSPOT: "hubspot",
  SALESFORCE: "salesforce",
  CUVAMA_DISCOVERY: "cuvama-discovery"
} as const;

export default IntegrationNames;
